// Module
var code = "<div> <legend> <span class=\"co-step-bubble\">{{stepNumber}}</span> <span class=\"co-legend-title\">{{stepTitle}}</span> <information-outline-icon :id=\"infoId || ''\" title=\"informationIconTitle\" class=\"clickable align-text-super\" :size=\"20\" fillColor=\"#095394\" @click=\"showContentPage(contentPage)\"/> </legend> </div> ";
// Exports
module.exports = code;